// Icon mapping utilities for Whiskey Sensei
// All icons now use Lucide React icon names

export const getQuestIcon = (questId: string): string => {
  const questIcons: { [key: string]: string } = {
    'galactic-spy': 'quest-spy',
    'ice-planet': 'quest-escape',
    'archive-hunt': 'quest-hunt',
    'sensei-trials': 'quest-trials',
    'time-paradox': 'quest-time'
  };
  return questIcons[questId] || 'quest';
};

export const getRankIcon = (level: number): string => {
  if (level >= 6) return 'rank-6';
  if (level >= 5) return 'rank-5';
  if (level >= 4) return 'rank-4';
  if (level >= 3) return 'rank-3';
  if (level >= 2) return 'rank-2';
  return 'rank-1';
};

export const getRankName = (level: number): string => {
  if (level >= 6) return 'Grand Master';
  if (level >= 5) return 'Master';
  if (level >= 4) return 'Expert';
  if (level >= 3) return 'Practitioner';
  if (level >= 2) return 'Apprentice';
  return 'Novice';
};

export const getBadgeIcon = (badgeType: string): string => {
  const badgeIcons: { [key: string]: string } = {
    'first-steps': 'badge-newcomer',
    'getting-consistent': 'badge-first',
    'point-collector': 'points',
    'speed-demon': 'badge-pilot',
    'perfect-score': 'badge-ace',
    'legendary': 'badge-emperor'
  };
  return badgeIcons[badgeType] || 'badges';
};

export const getLeaderboardIcon = (position: number): string => {
  if (position === 1) return 'position-1';
  if (position === 2) return 'position-2';
  if (position === 3) return 'position-3';
  return 'position-default';
};

export const getNavigationIcon = (path: string): string => {
  const navIcons: { [key: string]: string } = {
    '/': 'home',
    '/challenges': 'challenges',
    '/prompt-quest': 'quest',
    '/playground': 'playground',
    '/reference': 'reference',
    '/gamification': 'gamification',
    '/leaderboard': 'leaderboard',
    '/help-faq': 'help',
    '/profile': 'profile',
    '/admin': 'admin'
  };
  return navIcons[path] || 'home';
};

export const getDarkModeIcon = (isDark: boolean): string => {
  return isDark ? 'dark-mode' : 'light-mode';
};
